// Handlers
import handleBeforeInput from './handleBeforeInput';

export default () => ({
    handleBeforeInput,
});
